module.exports = __webpack_public_path__ + "img/2.dbce0cee.jpg";